import ViewSurveyForm from './viewSurveyForm.container'

export default ViewSurveyForm